const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

const ajaxFunctions = () => {
    const signupForm = document.querySelector('.c-signup-form__form');
    
    if ( signupForm ) {
        const submitBtn = signupForm.querySelector('.js-signup-form-submit');

        if ( submitBtn ) {            
            submitBtn.addEventListener('click', function(e) {                
                e.preventDefault();
    
                mailchimp(signupForm);
            });
        }
    }
};

const mailchimp = (signupForm) => {
    const formContainer = document.querySelector('.c-signup-form__container');
    const email = signupForm.querySelector('.c-signup-form__input').value;
    const emailErrorElem = signupForm.querySelector('.c-signup-form__email-error');
    const message = document.querySelector('.c-signup-form__message');

    // Remove any old error messages
    if ( !emailErrorElem.classList.contains('d-none') ) {
        emailErrorElem.classList.add('d-none');
    }

    if (validateEmail(email)) {        
        $.ajax({
            url: main__js_vars.ajaxurl,
            type: 'POST',
            data: {
                action: 'ajax_mailchimp',
                email: email,
            },
            beforeSend: function () {
                // Set the min-height of the container
                // formContainer.style.minHeight = formContainer.offsetHeight;
                formContainer.style.minHeight = '191px';
                
                // Fade out the signup form and show the message elem
                signupForm.classList.add('submitting');
                message.classList.remove('d-none');
            },
            success: function (data) {
                data = JSON.parse(data);
                console.log(data);
                
                // Remove the signup form
                signupForm.remove();

                // Update the message elem text
                message.innerHTML = data.message;
            }, 
            error: function (data) {
                data = JSON.parse(data);
                
                // Remove the signup form
                signupForm.remove();

                // Update the message elem text
                message.innerHTML = data.message;
            }
        });
        return false;
    } else {
        // Show the invalid email elem
        emailErrorElem.classList.remove('d-none');
    }
}